/* src/modules/course_approvals/selectors.js */

import { createSelector } from 'reselect';
import { isEmpty, map, maxBy, reduce } from 'lodash';
import { getMoment } from '../../util/dates';

export const getCourseApprovals = createSelector(
  state => state.courseApprovals.main.data,
  data => {
    const list = map(data, ({ _id, user: { first, last }, courses, organization }) => {
      if (isEmpty(courses)) return false;
      const latest = maxBy(courses, c => parseInt(c.requestedAt.timestamp, 10));
      const numApproved = reduce(courses, (sum, c) => (c.status === 'APPROVED' ? sum + 1 : sum), 0);
      const numPending = reduce(courses, (sum, c) => (c.status === 'PENDING' ? sum + 1 : sum), 0);

      const obj = {
        _id,
        _approved: numApproved / courses.length,
        _pending: numPending / courses.length,
        name: `${first} ${last}`,
        organization: organization.name,
        institution: latest.course.university.name,
        date: getMoment(latest.requestedAt.timestamp).format('MMM D, YYYY'),
        '# Approved': `${numApproved}/${courses.length}`,
      };
      if (numPending > 0)
        obj._color = 'yellow';
      return obj;
    }).filter(Boolean);
    list.sort((a, b) => b._pending - a._pending);
    return list;
  }
);

export const getSelectedCourses = createSelector(
  state => state.courseApprovals.main.data,
  state => state.courseApprovals.main.selected,
  (data, selected) => {
    const tutor = data[selected] || { courses: [], _id: '' };
    return map(tutor.courses, ({ course, status }) => ({
      fields: {
        'Course Code': `${course.subject} ${course.number}`,
        'Course Name': course.title,
        institution: course.university.name,
        _id: course._id,
      },
      status,
      user: tutor._id,
    }));
  }
);

export const getSelectedName = createSelector(
  state => state.courseApprovals.main.data,
  state => state.courseApprovals.main.selected,
  (data, selected) => {
    if (!data[selected]) return 'Select a tutor';
    const { user: { first, last } } = data[selected];
    return `${first} ${last}`;
  }
);

export const getTutorUniversities = createSelector(
  state => state.courseApprovals.main.data,
  state => state.courseApprovals.main.selected,
  (data, selected) => {
    if (!data[selected]) return [];
    const { universities } = data[selected];
    if (isEmpty(universities)) return [];
    return map(universities.filter(u => u), u => ({ label: u.name, value: u._id }));
  }
);

export const getSearchResult = createSelector(
  state => state.courses.search.data,
  courses => {
    const notFound = [];
    const found = [];
    const c = [];
    courses.forEach(({ _id, result }) => {
      if (!result) {
        notFound.push(_id.split(';')[0]);
      } else {
        found.push(`${result.subject} ${result.number}`);
        c.push({ _course: result._id });
      }
    });
    return {
      found: found.reduce((acc, x) => (acc ? `${acc}, ${x}` : x), ''),
      notFound: notFound.reduce((acc, x) => (acc ? `${acc}, ${x}` : x), ''),
      courses: c,
    };
  }
);

export const getUniversities = createSelector(
  state => state.auth.data.user.universities,
  universities => map(universities, '_id')
);

export const getOrganizations = createSelector(
  state => state.auth.data.user.organizations,
  organizations => map(organizations, o => ({ _id: o._id, name: o.name }))
);



// WEBPACK FOOTER //
// ./src/modules/course_approvals/selectors.js